import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AreaData } from '../model/area.model';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-areadetails',
  templateUrl: './areadetails.component.html',
  styleUrls: ['./areadetails.component.scss']
})
export class AreadetailsComponent implements OnInit {
  displayedColumns: string[] = ['areaCode', 'areaName', 'branchName', 'actions'];
  dataSource = new MatTableDataSource<AreaData>(null);
  area: AreaData = {
    areaCode: 0,
    areaName: '',
    branchName: ''
  }
  areas:AreaData [];
  enableButton = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private apiService: ApiService,private _snackBar: MatSnackBar) { 
    
  }
  ngOnInit(): void {
    this.getAreaData();
  }

  getAreaData() {
    this.apiService.getAreaDetails()
      .subscribe(data => {
        this.areas = data.areas;
        this.dataSource = new MatTableDataSource<AreaData>(data.areas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  validateAreaName(areaName: string){
    const valueExsist = this.areas.filter(function (item) {
        return item.areaName === areaName.trim();
    });
    if(valueExsist.length == 0 && areaName.trim() != ''){
      this.enableButton = true;
    } else{
      this.enableButton = false;
    }
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  addArea(area: AreaData) {    
      this.apiService.addNewArea(area).subscribe(data => {
        this.getAreaData();
        this.area.areaName = '';
        this.enableButton = false;
        this._snackBar.open('New area added', 'Close', {
          duration: 3000
        });
      });
      }

  deleteArea(area: AreaData) {
    this.apiService.deleteArea(area)
    .subscribe(data => {
      this.getAreaData();
      this._snackBar.open('Area deleted', 'Close', {
        duration: 3000
      });
    });
  }


}
